<script setup>
import { computed } from 'vue'

const props = defineProps({
  statusKey: {
    type: String,
    default: ''
  }
})

const STATUS_TEXT_MAP = {
  select_table: 'テーブルを抽出中',
  select_field: 'フィールドを分析中',
  create_sql: 'SQLを生成中',
  execute_sql: 'データを検索中',
  charts_build: 'グラフを作成中',
  data_analysis: 'データを分析中'
}

const statusText = computed(() => {
  return STATUS_TEXT_MAP[props.statusKey] || 'サービスに接続します'
})
</script>

<template>
  <div class="ai-thinking">
    <div class="pulse-dot"></div>
    <span class="thinking-text">{{ statusText }}</span>
    <span class="ellipsis">
      <i>.</i><i>.</i><i>.</i>
    </span>
  </div>
</template>

<style scoped>
.ai-thinking {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 14px;
  color: #9fb6ff;
  letter-spacing: 1px;
}

/* 左侧呼吸点 */
.pulse-dot {
  width: 8px;
  height: 8px;
  background: #00d1ff;
  border-radius: 50%;
  box-shadow: 0 0 8px #00d1ff;
  animation: pulse 1.5s infinite;
}

@keyframes pulse {
  0% { opacity: 0.3; }
  50% { opacity: 1; }
  100% { opacity: 0.3; }
}

/* 省略号动画 */
.ellipsis i {
  animation: blink 1.4s infinite both;
  font-style: normal;
}

.ellipsis i:nth-child(2) { animation-delay: 0.2s; }
.ellipsis i:nth-child(3) { animation-delay: 0.4s; }

@keyframes blink {
  0% { opacity: 0.2; }
  20% { opacity: 1; }
  100% { opacity: 0.2; }
}
</style>
